import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton";
import { VETTED_PLACES_WORLDWIDE } from '@/constants';

export const Statement = ({ onAnswer }) => {
    const [showFirstLine, setShowFirstLine] = useState(false);
    const [showSecondLine, setShowSecondLine] = useState(false);
    const [showBubbles, setShowBubbles] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        setTimeout(() => setShowFirstLine(true), 200);
        setTimeout(() => setShowSecondLine(true), 600);
        setTimeout(() => setShowBubbles(true), 400);
        setTimeout(() => setShowButton(true), 1400);
    }, []);

    const handleContinue = () => {
        setIsExiting(true);
        setTimeout(() => onAnswer('continue'), 800);
    };

    return (
        <div className={classNames(
            "relative h-full flex flex-col items-center justify-start px-6",
            "transition-all duration-800",
            isExiting ? "opacity-0" : "opacity-100"
        )}>
            <div className="text-center space-y-4 max-w-[600px] mt-4">
                <div className="overflow-hidden">
                    <h2
                        className={classNames(
                            "text-[32px] md:text-[40px] leading-tight font-bold transition-all duration-500 text-black",
                            showFirstLine ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                        )}
                    >
                        Great choices!
                        <br />
                        Atly has over{' '}
                        <span className="animate-shimmer bg-[length:200%_100%] bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                            {VETTED_PLACES_WORLDWIDE} gluten-free places
                        </span>{' '}
                        for you to explore
                    </h2>
                </div>

                <div className="overflow-hidden">
                    <h3
                        className={classNames(
                            "text-xl md:text-2xl text-gray-600 transition-all duration-500",
                            showSecondLine ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                        )}
                    >
                        New places are added daily
                    </h3>
                </div>
            </div>

            <div
                className={classNames(
                    "flex-1 w-full max-w-[600px] mx-auto relative mt-12",
                    "transition-all duration-800",
                    !showBubbles ? "opacity-0 scale-95" : "opacity-100 scale-100"
                )}
            >
                <div className="grid grid-cols-3 gap-4">
                    {[...Array(9)].map((_, i) => (
                        <div
                            key={i}
                            className={classNames(
                                "aspect-square rounded-2xl",
                                "bg-gradient-to-tr from-pink-50 to-orange-50",
                                "border border-pink-100/50",
                                "shadow-lg shadow-orange-100/20",
                                "flex items-center justify-center",
                                "transition-all duration-500",
                                "animate-float",
                                !showBubbles ? "opacity-0 scale-75" : "opacity-100 scale-100"
                            )}
                            style={{
                                transitionDelay: `${1000 + (i * 150)}ms`,
                                animationDelay: `${i * 200}ms`
                            }}
                        >
                            <span className="text-3xl">
                                {['🍽️', '🍷', '🥗', '🥘', '🍜', '🥪', '🍕', '🍗', '🍣'][i]}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            <div
                className={classNames(
                    "fixed bottom-0 left-0 right-0 p-5 transition-all duration-500 bg-gradient-to-t from-white via-white to-transparent pb-6 pt-10",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}
            >
                <PorangeButton
                    full={true}
                    className="h-[56px] rounded-[16px] text-lg shadow-md"
                    onClick={handleContinue}
                >
                    Continue
                </PorangeButton>
            </div>

            <style jsx global>{`
                @keyframes float {
                    0%, 100% {
                        transform: translateY(0) rotate(0deg) scale(1);
                    }
                    50% {
                        transform: translateY(-8px) rotate(2deg) scale(1.02);
                    }
                }

                .animate-float {
                    animation: float 3s ease-in-out infinite;
                    animation-play-state: running;
                }

                @keyframes shimmer {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }

                .animate-shimmer {
                    animation: shimmer 3s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default Statement;